import { render, staticRenderFns } from "./AddGrade.vue?vue&type=template&id=d45cd442&scoped=true"
import script from "./AddGrade.vue?vue&type=script&lang=js"
export * from "./AddGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45cd442",
  null
  
)

export default component.exports